import { Button, Form, Typography } from '@cannect/new-components/atoms'
import { LuCalendar, LuUpload } from 'react-icons/lu'
import { useHistory } from 'react-router-dom'
import { jaTemReceitaImagePath, seuCuidadoImagePath } from './actionCardsData'

export default function ActionCards() {
  const history = useHistory()
  return (
    <section className="py-12">
      <div className="grid gap-6 sm:grid-cols-3">
        <div className="h-fit rounded bg-secondary-100 shadow-sm">
          <img src={seuCuidadoImagePath} alt="Consulta médica" className="h-[184px] w-full object-cover" />
          <div className="flex flex-col items-center justify-center gap-6 p-8">
            <Typography.Heading type="headingSix" className="mb-4 text-neutral-800">
              Seu cuidado começa aqui. Consulte um médico parceiro.
            </Typography.Heading>
            <Button
              variant="outline"
              icon={<LuCalendar />}
              iconPlacement="left"
              full
              onClick={() => history.push('/agendamento')}>
              Agendar Consulta
            </Button>
          </div>
        </div>

        <div className="h-fit rounded bg-secondary-100 shadow-sm">
          <img src={jaTemReceitaImagePath} alt="Envie sua receita" className="h-[184px] w-full object-cover" />
          <div className="flex flex-col items-center justify-center gap-6 p-8">
            <Typography.Heading type="headingSix" className="mb-4 text-neutral-800">
              Já tem receita? Envie aqui e siga seu tratamento.
            </Typography.Heading>
            <Button
              variant="outline"
              icon={<LuUpload />}
              iconPlacement="left"
              full
              onClick={() => history.push('/jornada-digital')}>
              Envie sua receita
            </Button>
          </div>
        </div>

        {/* Card removido temporariamente (captação de leads) */}
      </div>
    </section>
  )
}
